const initialState = {
  constant: {
    jobs: {
      states: [],
      tags: [],
      quantity_units: [],
    },
    tasks: {
      states: [],
      tags: [],
      time_types: [],
      quantity_units: [],
    },
    billing_accounts: [],
  },
  countryList: [],
};

function constant(state = initialState, action) {
  switch (action.type) {
    case 'RECEIVE_CONSTANTS':
      return {
        ...state,
        constant: {
          ...action.constants,
        },
      };
    case 'RECEIVE_COUNTRIES':
      return {
        ...state,
        countryList: action.countries,
      };
    default:
      return state;
  }
}

export default constant;
